var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Users Panel'}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"ml-2 col-md-12"},[_c('appResult')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/users/UsersPanel.vue